<template>
  <div
    class="color-circle"
    :class="{ selected: isSelected }"
    :title="(color && color.name) || 'No color'"
  >
    <div class="white-border">
      <div
        class="color-fill"
        v-bind:style="{ backgroundColor }"
        :class="{ 'none-color': !color || !color.id }"
      ></div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "ColorCircle",
  props: ["color", "selectedColorId", "readOnly"],
  methods: {
    emitSelectColor(data) {
      this.$emit("selectColor", data);
    },
  },
  computed: {
    ...mapGetters("project", ["isShowroom"]),
    backgroundColor() {
      return this.color
        ? this.color.hex
        : !this.isShowroom
        ? "transparent"
        : "white";
    },
    isSelected() {
      return (
        (this.color &&
          Number(this.color?.id) === Number(this.selectedColorId)) ||
        (this.color?.name === "None" && !this.selectedColorId)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
$border-width: 3px;
$border-radius: 2.25rem;
.color-circle {
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.16);
  border-radius: $border-radius;
  width: 30px;
  height: 30px;

  .white-border {
    border: $border-width solid #ffffff;
    border-radius: $border-radius;
    width: 100%;
    height: 100%;

    .color-fill {
      border-radius: $border-radius;
      width: 100%;
      height: 100%;
      border: 1px solid $grey-light;
      position: relative;
      &.none-color::before {
        content: "";
        position: absolute;
        top: 0px;
        left: 10px;
        width: 2px;
        height: 100%;
        background: linear-gradient(to bottom right, #ff0000, #ff0000);
        transform: rotate(45deg);
      }
    }
  }

  &.selected {
    border: $border-width solid black;
    .none-color::before {
      left: 7px !important;
    }
  }
}
</style>